import React, { useEffect, useState } from 'react';

import './date-time.scss';

const DateTime = () => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setDate(new Date());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const formatDate = () => {
    let hour: number | string = date.getHours();
    let minute: number | string = date.getMinutes();
    let second: number | string = date.getSeconds();
    let day: number | string = date.getDate();
    let month: number | string = date.getMonth() + 1;
    const year: number | string = date.getFullYear();

    if (hour < 10) {
      hour = `0${hour}`;
    }

    if (minute < 10) {
      minute = `0${minute}`;
    }

    if (second < 10) {
      second = `0${second}`;
    }

    if (day < 10) {
      day = `0${day}`;
    }

    if (month < 10) {
      month = `0${month}`;
    }

    return `${hour}:${minute}:${second} ${day}/${month}/${year}`;
  };

  return (
    <div className="date-time">
      <p>{formatDate()}</p>
    </div>
  );
};

export default DateTime;
